// core/services/spinner.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
    private pending = 0;
    private _isLoading = new BehaviorSubject<boolean>(false);
    isLoading = this._isLoading.asObservable();

    // Umbrales de UX (ajustables)
    private showDelayMs = 320; // evita flash en cambios de vista muy rapidos
    private hideDelayMs = 100; // pequeña inercia para evitar flash
    private showTimer: any | null = null;

    /** NUEVO API */
    requestStarted() {
        this.pending++;
        if (this.pending === 1) {
            this.clearShowTimer();
            this.showTimer = setTimeout(() => {
                if (this.pending > 0) this._isLoading.next(true);
            }, this.showDelayMs);
        }
    }

    requestFinished() {
        if (this.pending > 0) this.pending--;
        if (this.pending === 0) {
            this.clearShowTimer();
            setTimeout(() => this._isLoading.next(false), this.hideDelayMs);
        }
    }

    /** COMPAT: mapea tu API vieja para no romper llamadas existentes */
    toggleLoading(show: boolean) {
        if (show) this.requestStarted();
        else this.requestFinished();
    }

    private clearShowTimer() {
        if (this.showTimer) {
            clearTimeout(this.showTimer);
            this.showTimer = null;
        }
    }
}
